import { gql } from '@apollo/client';

export const getProductsForSupplierQuery = gql`
  query GetProductsForSupplier($supplierId: Int!, $sessionId: String!) {
    productsForSupplier(supplierId: $supplierId, sessionId: $sessionId) {
      id
      name
      identifier
      type
      usp
      description
      active
      associatedSuppliers
      price
      main
      customFields {
        pvMultipleOptions
        pvOptionsDynamicProduct
        pvSortOrder
      }
    }
  }
`;

export default getProductsForSupplierQuery;
